import { render } from "./ModifyMemberDetailsDialog.vue?vue&type=template&id=2845ee2c&scoped=true"
import script from "./ModifyMemberDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ModifyMemberDetailsDialog.vue?vue&type=script&lang=js"

import "./ModifyMemberDetailsDialog.vue?vue&type=style&index=0&id=2845ee2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2845ee2c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QSlideItem from 'quasar/src/components/slide-item/QSlideItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QList,QSlideItem,QItem,QItemSection,QItemLabel,QIcon,QTooltip,QBtn,QCardActions,QInnerLoading});qInstall(script, 'directives', {ClosePopup});
